import { render, staticRenderFns } from "./newAdvertis.vue?vue&type=template&id=4dceaf6b&scoped=true&"
import script from "./newAdvertis.vue?vue&type=script&lang=js&"
export * from "./newAdvertis.vue?vue&type=script&lang=js&"
import style0 from "./newAdvertis.vue?vue&type=style&index=0&id=4dceaf6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dceaf6b",
  null
  
)

export default component.exports